<template lang="html">
  <span
    class="wind-compass"
    :style="styleCompass">
    <span
      class="spin"
      :style="styleSpin">
      <span
        class="needle"
        :style="styleNeedle" />
    </span>
  </span>
</template>

<script>
export default {
  name: 'WindCompass',
  props: {
    color: {
      type: String,
      default: '#000'
    },
    deg: {
      type: Number,
      default: 0
    }
  },
  computed: {
    styleNeedle () {
      const borderColor = `transparent transparent ${this.color} transparent`
      return { borderColor }
    },
    styleSpin () {
      const transform = `rotate(${this.deg}deg)`
      return { transform }
    },
    styleCompass () {
      const borderColor = this.color
      return { borderColor }
    }
  }
}
</script>

<style lang="scss">
.wind-compass {
  display: inline-block;
  position: relative;
  vertical-align: middle;
  width: 12px;
  height: 12px;
  border: 1px solid #000;
  border-radius: 50%;
  .spin {
    position: relative;
    display: block;
    width: 12px;
    height: 12px;
    transition: transform .2s ease-in-out;
    transform-origin: center center;
  }
  .needle {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 3px 8px 3px;
    transform: translate(-50%,-60%);
  }
}
</style>
